import ListGroup from '@pelckmans/elementis/components/list-group';
import Section from '@pelckmans/elementis/components/section';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Medialink } from '../../../../../api/medialink';
import { ANALYTICS_EVENT_SUBLOCATIONS } from '../../../../../constants/analyticsEvents';
import ModuleContext from '../../../_contexts/ModuleContext';
import MedialinkList from '../MedialinkList';
import { groupByContentType } from '../utils';

function splitUpMedialinksInExerciseAndNoneExercise(medialinks: Medialink[]) {
  const [exerciseMedialinks, noneExerciseMedialinks] = medialinks.reduce<[Medialink[], Medialink[]]>(
    ([exerciseMedialinks, noneExerciseMedialinks], medialink) => {
      if (medialink.contentType.isExercise) {
        exerciseMedialinks.push(medialink);
      } else {
        noneExerciseMedialinks.push(medialink);
      }
      return [exerciseMedialinks, noneExerciseMedialinks];
    },
    [[], []],
  );

  return {
    exercisesByContentType: groupByContentType(exerciseMedialinks),
    noneExercisesByContentType: groupByContentType(noneExerciseMedialinks),
  };
}

type MedialinkSectionsProps = {
  medialinks: Medialink[];
};

export default function MedialinkSections({ medialinks }: MedialinkSectionsProps) {
  const { t } = useTranslation();
  const { selectedModule } = useContext(ModuleContext);

  const { exercisesByContentType, noneExercisesByContentType } = splitUpMedialinksInExerciseAndNoneExercise(medialinks);

  return (
    <>
      {Object.keys(exercisesByContentType).length > 0 && (
        <Section title={t(`PAGES.TOC_LEVEL.SECTIONS.STUDENT.EXERCISE.TITLE`)}>
          <ListGroup>
            {Object.keys(exercisesByContentType).map(category => (
              <MedialinkList
                key={category}
                medialinks={exercisesByContentType[category]}
                title={category}
                subLocationId={
                  selectedModule?.isExerciseModule
                    ? ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_EXERCISE_MODULE_EXERCISE_MATERIAL
                    : ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_MODULE_EXERCISE_MATERIAL
                }
              />
            ))}
          </ListGroup>
        </Section>
      )}
      <Section
        title={t(`PAGES.TOC_LEVEL.SECTIONS.STUDENT.OTHER_MATERIAL.TITLE`)}
        emptyMessage={t(`PAGES.TOC_LEVEL.SECTIONS.STUDENT.OTHER_MATERIAL.EMPTY_MESSAGE`)}
      >
        {Object.keys(noneExercisesByContentType).length > 0 && (
          <ListGroup>
            {Object.keys(noneExercisesByContentType).map(category => (
              <MedialinkList
                key={category}
                medialinks={noneExercisesByContentType[category]}
                title={category}
                subLocationId={
                  selectedModule?.isExerciseModule
                    ? ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_EXERCISE_MODULE_OTHER_MATERIAL
                    : ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_MODULE_OTHER_MATERIAL
                }
              />
            ))}
          </ListGroup>
        )}
      </Section>
    </>
  );
}
